module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "navbar",
    class: _vm.cls,
    style: (_vm.styleObj)
  }, [(_vm.back) ? _c('a', {
    staticClass: "navbar-left navbar-btn action-back",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$router.back()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "navbar-title"
  }, [_vm._t("title")], 2), _vm._v(" "), _vm._t("right"), _vm._v(" "), _vm._t("subbar")], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4023ccb4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navbar/navbar.vue
// module id = 348
// module chunks = 1